import { Drawer } from 'vaul';
import { useState } from 'react';
import { MoreHorizontal, Trash2, ArrowLeft } from 'lucide-react';

export function BottomSheet({ title, children, onClose, open, onDelete, isEditable, onBack, modal=false }) {

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Drawer.Root open={open} modal={modal} repositionInputs={false} onOpenChange={(o) => !o && onClose()}>
      <Drawer.Portal>
        {modal && (
          <Drawer.Overlay className="fixed inset-0 bg-black/40 z-[998]" />
        )}
        <Drawer.Content 
  className="fixed bottom-0 left-0 right-0 z-[1000] bg-white rounded-t-2xl outline-none"
  style={{ overflow: 'visible' }}
  tabIndex={undefined}
>
          {/* Ручка для свайпа */}
          <div className="flex justify-center pt-3 pb-1">
            <div className="w-10 h-1 rounded-full bg-gray-300" />
          </div>
          
          {/* Заголовок */}
          <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {onBack && (
                <button
                  onClick={onBack}
                  style={{
                    background: '#f5f5f5',
                    border: 'none',
                    borderRadius: '50%',
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    color: '#374151'
                  }}
                >
                  <ArrowLeft size={16} />
                </button>
              )}
              <span className="text-lg font-semibold text-gray-900">{title}</span>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {/* Кнопка три точки */}
              {isEditable && (
                <div className="relative">
                  <button 
                    onClick={() => setMenuOpen(!menuOpen)}
                    className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-gray-500"
                  >
                    <MoreHorizontal size={18} />
                  </button>

                  {/* Выпадающее меню */}
                  {menuOpen && (
                    <>
                      {/* Закрытие меню по клику вне */}
                      <div 
                        className="fixed inset-0 z-[1001]" 
                        onClick={() => setMenuOpen(false)} 
                      />
                      <div className="absolute right-0 top-10 z-[1002] bg-white rounded-xl shadow-lg border border-gray-100 min-w-[150px] overflow-hidden">
                        <button
                          onClick={() => { setMenuOpen(false); onDelete(); onClose(); }}
                          className="flex items-center gap-3 w-full px-4 py-3 text-sm text-red-500 hover:bg-red-50"
                        >
                          <Trash2 size={16} />
                          Удалить
                        </button>
                      </div>
                    </>
                  )}
                </div>
              )}

              {/* Кнопка закрыть */}
              <button 
                onClick={onClose}
                className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-gray-500"
              >
                ✕
              </button>
            </div>
          </div>
          

          {/* Контент */}
          <div className="px-5 pt-4" 
  style={{ 
    paddingBottom: 'max(16px, env(safe-area-inset-bottom))',
    overflowY: 'auto',
    maxHeight: '70vh'
  }}
>
  {children}
</div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}